import { useEffect, useRef, useState } from 'react';

export default function PreviewTitle({ file, onRename }) {
    const name = file.file_name || '';
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(name);
    const cancelledRef = useRef(false);

    useEffect(() => { setValue(name); }, [name]);

    const startEditing = () => {
        cancelledRef.current = false;
        setValue(name);
        setEditing(true);
    };

    const save = () => {
        setEditing(false);
        if (cancelledRef.current) return;
        const trimmed = value.trim();
        if (trimmed && trimmed !== name) onRename(trimmed);
        else setValue(name);
    };

    if (editing) {
        return (
            <input
                autoFocus
                className="pcq-preview-title-input"
                value={value}
                onChange={e => setValue(e.target.value)}
                onFocus={e => {
                    const dot = e.target.value.lastIndexOf('.');
                    e.target.setSelectionRange(0, dot > 0 ? dot : e.target.value.length);
                }}
                onKeyDown={e => {
                    if (e.key === 'Enter') e.currentTarget.blur();
                    if (e.key === 'Escape') {
                        cancelledRef.current = true;
                        setValue(name);
                        setEditing(false);
                    }
                }}
                onBlur={save}
            />
        );
    }

    return (
        <div className="pcq-preview-title-wrap">
            <span className="pcq-preview-title" title={name} onDoubleClick={startEditing}>📄 {name || 'Preview'}</span>
            <button type="button" className="pcq-preview-rename" title="Rename file" onClick={startEditing}>✏️</button>
        </div>
    );
}
